var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C19.7894 4 15.9168 4.77847 13.05 6.09039C10.2931 7.35204 8 9.34893 8 12C8 14.6511 10.2931 16.648 13.05 17.9096C15.9168 19.2215 19.7894 20 24 20C28.2106 20 32.0832 19.2215 34.95 17.9096C37.7069 16.648 40 14.6511 40 12C40 9.34893 37.7069 7.35204 34.95 6.09039C32.0832 4.77847 28.2106 4 24 4Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.5244C9.20616 18.6978 10.6773 19.5731 12.0097 20.1829C15.2717 21.6756 19.5145 22.5 24 22.5C28.4855 22.5 32.7283 21.6756 35.9903 20.1829C37.3227 19.5731 38.7938 18.6978 40 17.5244V36.25H39.9932C39.8542 38.7769 37.6196 40.6879 34.95 41.9096C32.0832 43.2215 28.2106 44 24 44C19.7894 44 15.9168 43.2215 13.05 41.9096C10.3804 40.6879 8.14576 38.7769 8.00685 36.25H8V17.5244Z",
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/Database.6fccdc90f9135cb6e5585bf7873a100e.svg";
export { ForwardRef as ReactComponent };